import axios from 'axios';
import _ from 'lodash';
import { helperGetApiHeaders, helperGetApiRouteById, apiErrorHandler } from 'helpers/ApiHelper';
import { setVideoPanel as setGlobalVideoPanel } from 'components/VideoPlayerGlobal/Actions';
import { PAGE_WATCH } from 'helpers/PageHelper';
import { fetchFooter } from 'components/Footer/FooterActions';

export const CLEAR_WATCH = 'CLEAR_WATCH';
export const FETCH_MOVIE_DETAIL = 'FETCH_MOVIE_DETAIL';
export const FETCH_WATCH = 'FETCH_WATCH';
export const FETCH_WATCH_ERROR = 'FETCH_WATCH_ERROR';
const FETCH_WATCH_PANELS = 'FETCH_WATCH_PANELS';
export const SET_WATCH_PANELS = 'SET_WATCH_PANELS';
export const SET_NEXT_PAGE = 'SET_NEXT_WATCH_PAGE';

export function fetchWatch(id, accessToken, deviceId) {
  const pageType = 'videoDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_WATCH,
    payload: request,
  };
}

function setWatchPanels(data) {
  return {
    type: SET_WATCH_PANELS,
    payload: data,
  };
}

export const fetchWatchPanels = (
  id,
  accessToken,
  deviceId,
  doNotSetGlobalVideoPanel,
) => dispatch => {
  dispatch({ type: FETCH_WATCH_PANELS });
  const pageType = 'videoDetail';
  return axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .then(results => {
      // to allow quick render set panels before fetching pagination
      const panels = _.get(results, 'data.panels.member');
      const firstPanel = _.get(panels, '0');
      if (!firstPanel) throw new Error('404');
      dispatch(setWatchPanels(results));
      if (doNotSetGlobalVideoPanel) return;
      dispatch(setGlobalVideoPanel({ panel: firstPanel, source: PAGE_WATCH }));
    })
    .catch(errors => {
      apiErrorHandler(errors);
      dispatch({ type: FETCH_WATCH_ERROR, payload: errors });
    })
    .then(() => dispatch(fetchFooter()));
};

export function fetchMovieDetail(id, accessToken, deviceId) {
  const pageType = 'movieVideoDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_MOVIE_DETAIL,
    payload: request,
  };
}

export function clearWatch() {
  return {
    type: CLEAR_WATCH,
  };
}
